import { render, staticRenderFns } from "./TakipVeTahsilatHaftalikGrafik.vue?vue&type=template&id=33718081"
import script from "./TakipVeTahsilatHaftalikGrafik.vue?vue&type=script&lang=ts"
export * from "./TakipVeTahsilatHaftalikGrafik.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports